<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6 overflow-y-auto max-h-[80vh]">
      <h2 class="text-lg font-bold mb-4">{{ isEditing ? 'Редактировать пользователя' : 'Добавить пользователя' }}</h2>

      <form @submit.prevent="submitForm">
        <!-- Логин -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Логин</label>
          <input
            type="text"
            v-model="form.name"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите логин"
          />
        </div>

        <!-- Email -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            v-model="form.email"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите email"
          />
        </div>

        <!-- Пароль -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Пароль</label>
          <input
            type="password"
            v-model="form.password"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите пароль"
          />
        </div>

        <!-- ПИН-код -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">ПИН-код (4 цифры)</label>
          <input
            type="text"
            v-model="form.pin_code"
            maxlength="4"
            pattern="[0-9]{4}"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите 4-значный ПИН-код"
          />
        </div>

        <!-- Имя -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Имя</label>
          <input
            type="text"
            v-model="form.first_name"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите имя"
          />
        </div>

        <!-- Фамилия -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Фамилия</label>
          <input
            type="text"
            v-model="form.last_name"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите фамилию"
          />
        </div>

        <!-- Отчество -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Отчество</label>
          <input
            type="text"
            v-model="form.patronymic"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите отчество"
          />
        </div>

        <!-- Роль -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Роль</label>
          <select
            v-model="form.role_id"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option disabled value="">Выберите роль</option>
            <option v-for="role in roles" :key="role.id" :value="role.id">
              {{ role.name }}
            </option>
          </select>
        </div>

        <!-- Начальный модуль -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Начальный модуль</label>
          <select
            v-model="form.start_module_id"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option disabled value="">Выберите модуль</option>
            <option v-for="module in modules" :key="module.id" :value="module.id">
              {{ module.name }}
            </option>
          </select>
        </div>

        <!-- Модули роли: только для чтения, набор задаётся матрицей доступа роли -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Модули</label>
          <p class="text-xs text-gray-500 mb-2">Доступ задаётся ролью</p>
          <ul v-if="roleModules.length" class="text-sm text-gray-700 space-y-1">
            <li v-for="module in roleModules" :key="module.id" class="flex justify-between gap-2">
              <span>{{ module.name }}</span>
              <span class="text-gray-500">{{ module.level }}</span>
            </li>
          </ul>
          <p v-else-if="matrixError" class="text-sm text-red-600">
            {{ matrixError }}
          </p>
          <p v-else class="text-sm text-gray-500">
            {{ form.role_id ? 'У роли нет модулей' : 'Выберите роль' }}
          </p>
        </div>

        <!-- Кнопки -->
        <div class="flex justify-end space-x-2">
          <button
            type="button"
            @click="closeModal"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Отмена
          </button>
          <button
            type="submit"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {{ isEditing ? 'Сохранить' : 'Добавить' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// Имя суперроли: её доступы не хранятся в матрице — она получает все модули
const SUPER_ROLE_NAME = 'Администратор';

// Подписи уровней доступа (App\Enums\AccessLevels)
const ACCESS_LABELS = {
  full: 'Полный',
  read: 'Только чтение',
};

export default {
  data() {
    return {
      visible: false,
      form: {
        id: null, // ID пользователя (для редактирования)
        name: '', // Логин
        email: '', // Email
        password: '', // Пароль
        pin_code: '', // ПИН-код
        first_name: '', // Имя
        last_name: '', // Фамилия
        patronymic: '', // Отчество
        role_id: '', // ID роли
        start_module_id: '', // ID начального модуля
      },
      isEditing: false, // Флаг для определения режима редактирования
      roles: [], // Список ролей
      modules: [], // Список модулей
      matrix: {}, // Матрица доступа: {roleId: {modules: {moduleId: level}, sections: {...}}}
      matrixError: '', // Текст ошибки загрузки ролей и доступов — показывается в месте списка модулей
    };
  },
  computed: {
    /**
     * Модули выбранной роли с уровнем доступа — список только для чтения.
     */
    roleModules() {
      const roleId = this.form.role_id ? Number(this.form.role_id) : null;
      if (!roleId) return [];

      const role = this.roles.find((item) => item.id === roleId);
      if (role && role.name === SUPER_ROLE_NAME) {
        return this.modules.map((module) => ({
          id: module.id,
          name: module.name,
          level: ACCESS_LABELS.full,
        }));
      }

      const levels = this.matrix[String(roleId)]?.modules || {};

      return this.modules
        .filter((module) => levels[String(module.id)])
        .map((module) => ({
          id: module.id,
          name: module.name,
          level: ACCESS_LABELS[levels[String(module.id)]] || levels[String(module.id)],
        }));
    },
  },
  created() {
    this.fetchMatrix();
  },
  methods: {
    /**
     * Роли, модули и матрица доступа — одним запросом: набор модулей
     * пользователя показывается по матрице его роли.
     */
    fetchMatrix() {
      this.matrixError = '';

      axios
        .post('/api/role/getMatrix')
        .then((response) => {
          const data = response.data.data;
          this.roles = data.roles || [];
          this.modules = data.modules || [];
          this.matrix = data.matrix || {};
        })
        .catch((error) => {
          // Без ролей и модулей карточка неработоспособна: молча пустые списки не показываем
          console.error('Ошибка при загрузке ролей и модулей:', error);

          const data = error.response?.data;
          const firstValidationError = data?.errors ? Object.values(data.errors)[0]?.[0] : null;
          const message =
            firstValidationError || data?.message || 'Не удалось загрузить роли и доступы. Обновите страницу.';

          this.matrixError = message;
          this.$root.$toast?.error?.(message);
        });
    },
    submitForm() {
      if (!this.form.name || !this.form.email || !this.form.role_id || !this.form.start_module_id) {
        console.error('Заполните все обязательные поля');
        return;
      }

      const url = '/api/user/createOrUpdateUser'; // Один URL для создания и обновления

      axios
        .post(url, this.form) // Передаем ID в теле запроса, если он есть
        .then(() => {
          this.visible = false; // Закрываем модальное окно
          this.resetForm(); // Очищаем форму
          this.$emit('user-updated'); // Уведомляем родителя о действии
        })
        .catch((error) => {
          console.error('Ошибка при отправке данных:', error);
        });
    },
    resetForm() {
      this.form = {
        id: null,
        name: '',
        email: '',
        password: '',
        pin_code: '',
        first_name: '',
        last_name: '',
        patronymic: '',
        role_id: '',
        start_module_id: '',
      };
    },
    closeModal() {
      this.visible = false;
    },
    show(user = null) {
      if (user) {
        this.form = {...user}; // Заполняем форму данными пользователя
        delete this.form.modules; // Набор модулей задаётся ролью, из карточки не отправляется
        this.form.start_module_id = user.start_module?.id ?? user.start_module_id ?? '';
        this.isEditing = true;
      } else {
        this.resetForm();
        this.isEditing = false;
      }
      this.visible = true;
    },
  },
};
</script>
